export const PASSWORD_LENGTH = 6;

export const OTP_TIMEOUT_MS = 60000;

export const ACTION_TIMEOUT_DELAY = 500;
